import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton } from '@coreui/react-pro'
import { chartTxtTrim, downloadChartPDF } from '../../../../utils/sharedChartFunctions'
import FEATURES from '../../../../utils/featuresConstants'
import { isTestFeature } from '../../../../utils/sharedFeaturesFunctions'
import { getProgressNoteRegenerate } from '../../../../helper/backendHelper'
import { toast } from 'react-toastify'
import AddendumModal from '../../PatientDetails/AddendumModal'
import GenericConfirmModal from '../../census/components/ConfirmationModals/GenericConfirmModal'
import { putCollector } from '../../../../apiHelper/collectorApi'
import { COLLECTOR_URL } from '../../../../apiHelper/apiRoute/collector'
import { SYSTEM_ID } from '../../sharedConstants'
import { clearSidePanel } from '../../../../redux/sidePanel/sidePanelSlice'

export default function PanelCompletedNoteButtons() {
  const dispatch = useDispatch()
  const features = useSelector((state) => state.user.features)
  const provider = useSelector((state) => state.user.provider)

  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)
  const isLastEncounter = useSelector((state) => state.sidePanel.isLastEncounter)
  const panelChart = useSelector((state) => state.sidePanel.panelChart)

  const [showAddAddendum, setShowAddAddendum] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const isORUNote = panelChart?.signed_user_id === SYSTEM_ID

  return (
    <div id={'PanelCompletedNoteButtons'}>
      <CButton
        color="primary"
        size="sm"
        className="ms-2 "
        onClick={() => downloadChartPDF(panelEncounter)}
      >
        Download PDF
      </CButton>
      {!isORUNote && (
        <>
          {features?.includes(FEATURES.VisitNotesPOC) &&
            panelEncounter.rendering_provider_id !== provider?._id &&
            !panelChart?.cosigned_on && (
              <CButton
                color="primary"
                size="sm"
                className="ms-2"
                onClick={() => {
                  setShowConfirmModal(true)
                }}
              >
                Co-Sign
              </CButton>
            )}
          <CButton
            color="secondary"
            size="sm"
            onClick={() => {
              setShowAddAddendum(true)
            }}
          >
            Add Addendum
          </CButton>
          <CButton
            color="secondary"
            size="sm"
            onClick={() => {
              navigator.clipboard.writeText(chartTxtTrim(panelChart?.note_txt))
              toast.success('Note Copied!')
            }}
          >
            Copy Text
          </CButton>
        </>
      )}
      {isTestFeature() && (
        <CButton
          color="danger"
          size="sm"
          className="ms-2"
          onClick={() => getProgressNoteRegenerate(panelEncounter?._id)}
        >
          <i className="fa-solid fa-rotate-right"></i> Regenerate Note image
        </CButton>
      )}

      {/* modals to open */}
      {showConfirmModal && (
        <GenericConfirmModal
          onConfirm={() => {
            setShowConfirmModal(false)
            putCollector(COLLECTOR_URL.COSIGN, { charge_id: panelEncounter?._id })
              .then((data) => {
                if (data.status === 'success') {
                  toast.success(data.message || 'Chart cosigned successfully')
                } else {
                  toast.error(data?.message || 'Failed to cosign chart')
                }

                dispatch(clearSidePanel())
              })
              .catch((e) => {
                console.error(e)
                toast.error('Failed to cosign chart')
              })
          }}
          onClose={() => {
            setShowConfirmModal(false)
          }}
          content={`The note will be cosigned. This action can't be undone`}
        />
      )}

      {showAddAddendum && (
        <AddendumModal
          visit={{ ...panelEncounter, chart: panelChart, visitId: panelEncounter?._id }}
          setIsAddendumOpen={setShowAddAddendum}
          onCreateAddendumSuccess={() => {
            dispatch(clearSidePanel())
          }}
          hideButtons
        />
      )}
    </div>
  )
}
